import { Syncable } from "shared/state/models/syncable";
import { IMarking } from "shared/api/api";


export const SYNC_DATA_MARKINGS = 'SYNC_DATA_MARKINGS';

export interface MarkingsState extends Syncable<IMarking> {}
